import { Numeral, NumeralProps } from '../Numeral';

export interface MoneyProps extends NumeralProps {
  value?: number;

  /**
   * if not set, then numbers will be shown as-is.
   * - exception is that xyz.0 will be floored to xyz.
   */
  showDecimal?: boolean;

  /**
   * if true, 1000 -> 1k
   */
  isCompact?: boolean;
}

export const Money = (props: MoneyProps) => {
  // https://github.com/tc39/proposal-intl-numberformat-v3/issues/17
  // Workaround for negative signed values until this proposal is put in place
  const isValuePositive = props.value !== undefined && props.value !== 0 && props.value > 0;
  const signDisplay = isValuePositive ? 'auto' : 'exceptZero';
  return <Numeral {...props} isCurrency signDisplay={props.signDisplay ?? signDisplay} />;
};
